import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  decodeToken,
  OperationType,
  primaryIndustry,
} from '../../../../utils/settings';
import {
  createBusinessProfilerAction,
  getAllBrandMonthlyVolumeAction,
  getAllBusinessBrandsRangeAction,
  getAllBusinessIndustriesAction,
  getAllBusinessMonthlyTurnOverAction,
  getAllBusinessStoreTypesAction,
  getAllBusinessTypesOfProductsAction,
  getAllBusinessUomAction,
  getbusinessProfilerAction,
  patchbusinessProfilerAction,
} from '../../action';
import { toast, ToastContainer } from 'react-toastify';
import { getOnboardingIndustryAction } from '../../../Onboarding/auth/action';

function OtherBusinessDetails() {
  const [otherBusinessDetails, setOtherBusinessDetails] = useState({});
  const [businessDetails, setBusinessDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [firmDetails, setFirmDetails] = useState({});
  const [addedBrands, setAddedBrands] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState({});
  const [storetypeList, setStoretypeList] = useState([]);
  const [brandRangeList, setBrandRangeList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [industryList, setIndustryList] = useState([]);
  const [monthlyTurnOverList, setMonthlyTurnOverList] = useState([]);
  const [editing, setEditing] = useState(false);
  const [adding, setAdding] = useState(false);
  const [brandMonthlyVolumeList, setBrandMonthlyVolumeList] = useState([]);
  const [openNoOfBrands, setOpenNoOfBrands] = useState(false);

  const getIndustries = async () => {
    let response = {};
    if (selectedIndustry?.id === primaryIndustry['FMCG']) {
      response = await getAllBusinessStoreTypesAction();
    } else {
      response = await getAllBusinessIndustriesAction();
    }

    const { data, error, message } = response;

    if (!error) setStoretypeList(data);
    else toast.error(message);
  };

  useEffect(() => {
    getIndustries();
  }, [selectedIndustry]);

  // getOnboardingIndustryAction

  const getPrimaryIndustries = async () => {
    const { data, error, message } = await getOnboardingIndustryAction();

    if (!error) setIndustryList(data);
    else toast.error(message);
  };

  const getBrandRange = async () => {
    const { data, error, message } = await getAllBusinessBrandsRangeAction();

    if (!error) setBrandRangeList(data);
    else toast.error(message);
  };

  const getAllProductTypes = async () => {
    const { data, error, message } =
      await getAllBusinessTypesOfProductsAction();

    if (!error) setProductTypeList(data);
    else toast.error(message);
  };

  const getAllBrandMonthlyVolume = async () => {
    const { data, error, message } = await getAllBrandMonthlyVolumeAction();

    if (!error) setBrandMonthlyVolumeList(data);
    else toast.error(message);
  };

  const getAllMonthlyTurnOver = async () => {
    const { data, error, message } =
      await getAllBusinessMonthlyTurnOverAction();

    if (!error) setMonthlyTurnOverList(data);
    else toast.error(message);
  };

  const getAllUom = async () => {
    const { data, error, message } = await getAllBusinessUomAction();

    if (!error) setUomList(data);
    else toast.error(message);
  };

  const getprofiler = async () => {
    const { data, error, message } = await getbusinessProfilerAction();

    if (!error) setOtherBusinessDetails(data.other_businesses_details);
    else toast.error(message);
  };

  useEffect(() => {
    getprofiler();
    getBrandRange();
    getAllProductTypes();
    getAllMonthlyTurnOver();
    getAllUom();
    getPrimaryIndustries();
    getAllBrandMonthlyVolume();

    decodeToken().then(({ default_company_info }) => {
      setFirmDetails(default_company_info);
    });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setAddedBrands([]);
    setBusinessDetails({});
    setSelectedIndustry({});
    setEditing(false);
    setAdding(false);
  };

  const addBrand = () => {
    // return console.log(businessDetails);
    if (selectedIndustry?.id === primaryIndustry['FMCG']) {
      if (!businessDetails.store_type)
        return toast.error('Please Select Store Type');
      if (!businessDetails.no_of_brands_dealing_in)
        return toast.error('Please Select Number of Brands Dealing In');
      if (!businessDetails.types_of_products)
        return toast.error('Please Select Types of Products');
      if (!businessDetails.monthly_turnover_lacs)
        return toast.error('Please Select Monthly Turnover');
      if (!businessDetails.number_of_refrigerating_units)
        return toast.error('Please Enter Number of Refrigerating Units');

      if (!businessDetails.name) return toast.error('Please enter brand name');
      if (!businessDetails.brand_monthly_volume)
        return toast.error('Please Select Brand Monthly Volume');

      const payload = {
        brand_name: businessDetails.name,
        brand_monthly_volume: businessDetails.brand_monthly_volume,
        is_distributor: businessDetails.is_distributor === 'true',
        contact_person_name: businessDetails.contact_person_name,
        contact_person_number: businessDetails.contact_person_number,
      };

      setBusinessDetails({
        store_type: businessDetails.store_type,
        no_of_brands_dealing_in: businessDetails.no_of_brands_dealing_in,
        types_of_products: businessDetails.types_of_products,
        monthly_turnover_lacs: businessDetails.monthly_turnover_lacs,
        number_of_refrigerating_units:
          businessDetails.number_of_refrigerating_units,
      });
      setAddedBrands([...addedBrands, payload]);
      toast.success('Brand Saved');
    } else {
      if (!businessDetails.industry)
        return toast.error('Please Select Industry');
      if (!businessDetails.name) return toast.error('Please enter brand name');
      if (!businessDetails.uom) return toast.error('Please Select UOM');
      if (!businessDetails.value) return toast.error('Please enter value');
      if (!businessDetails.value_in_inr)
        return toast.error('Please enter value in Lacs');

      const payload = {
        brand_name: businessDetails.name,
        volume_info: {
          uom: businessDetails.uom,
          value: businessDetails.value,
          value_in_lacs: businessDetails.value_in_inr,
        },
      };

      setBusinessDetails({
        industry: businessDetails.industry,
      });
      setAddedBrands([...addedBrands, payload]);
      toast.success('Brand Saved');
    }
  };

  const onFinish = async () => {
    let payload = {};
    if (selectedIndustry?.id === primaryIndustry['FMCG']) {
      payload = {
        other_business_details: {
          firm_id: firmDetails.company_id,
          business_details: [
            {
              store_type: businessDetails.store_type,
              no_of_brands_dealing_in: businessDetails.no_of_brands_dealing_in,
              types_of_products: businessDetails.types_of_products,
              monthly_turnover_lacs: businessDetails.monthly_turnover_lacs,
              number_of_refrigerating_units:
                businessDetails.number_of_refrigerating_units,
              brand_list: addedBrands,
            },
          ],
        },
      };
    } else {
      payload = {
        other_business_details: {
          firm_id: firmDetails.company_id,
          business_details: [
            {
              industry: businessDetails.industry,
              brand_list: addedBrands,
            },
          ],
        },
      };
    }

    // return console.log(payload);

    const { error, message } = await createBusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      handleClose();
      toast.error(message);
    }
  };

  const onAdding = (data) => {
    // return console.log(data);
    setAdding(true);
    setOpen(true);

    const isFmcg = !data.industry;

    if (isFmcg) {
      setSelectedIndustry(
        industryList.find((i) => i.id === primaryIndustry['FMCG']),
      );
    } else {
      setSelectedIndustry(
        industryList.find((i) => i.id === primaryIndustry['BCM']),
      );
    }

    let payload = {
      parent_id: data.id,
    };

    if (isFmcg) {
      payload = {
        ...payload,
        store_type: data.store_type,
        no_of_brands_dealing_in: data.no_of_brands_dealing_in,
        types_of_products: data.types_of_products,
        monthly_turnover_lacs: data.monthly_turnover_lacs,
        number_of_refrigerating_units: data.number_of_refrigerating_units,
      };
    } else {
      payload = {
        ...payload,
        industry: data.industry,
      };
    }

    // return console.log(payload);

    setBusinessDetails(payload);
  };

  const onEdit = (data, brand, isBcm) => {
    setEditing(true);
    setOpen(true);

    let payload = {};

    if (!isBcm) {
      setSelectedIndustry(
        industryList.find((i) => i.id === primaryIndustry['FMCG']),
      );
      payload = {
        parent_id: data.id,
        store_type: data.store_type,
        no_of_brands_dealing_in: data.no_of_brands_dealing_in,
        types_of_products: data.types_of_products,
        monthly_turnover_lacs: data.monthly_turnover_lacs,
        number_of_refrigerating_units: data.number_of_refrigerating_units,
        name: brand.brand_name,
        id: brand.id,
        brand_monthly_volume: brand.brand_monthly_volume,
        is_distributor: brand.is_distributor ? 'true' : 'false',
        contact_person_name: brand.contact_person_name,
        contact_person_number: brand.contact_person_number,
      };
    } else {
      setSelectedIndustry(
        industryList.find((i) => i.id === primaryIndustry['BCM']),
      );
      payload = {
        parent_id: data.id,
        id: brand.id,
        industry: data.industry,
        name: brand.brand_name,
        uom: brand.volume_info.uom,
        value: brand.volume_info.value,
        value_in_inr: brand.volume_info.value_in_lacs,
      };
    }

    setBusinessDetails(payload);
  };

  const onEditFinish = async (add) => {
    if (!businessDetails.name) return toast.error('Please enter brand name');

    let payload = {};
    if (selectedIndustry?.id === primaryIndustry['FMCG']) {
      if (!businessDetails.brand_monthly_volume)
        return toast.error('Please Select Brand Monthly Volume');

      payload = {
        other_business_details: {
          firm_id: firmDetails.company_id,
          business_details: [
            {
              id: businessDetails.parent_id,
              brand_list: [
                {
                  id: businessDetails.id,
                  brand_name: businessDetails.name,
                  brand_monthly_volume: businessDetails.brand_monthly_volume,
                  is_distributor: businessDetails.is_distributor === 'true',
                  contact_person_name: businessDetails.contact_person_name,
                  contact_person_number: businessDetails.contact_person_number,
                  operation_type: add
                    ? OperationType['ADD']
                    : OperationType['UPDATE'],
                },
              ],
            },
          ],
        },
      };
    } else {
      if (!businessDetails.uom)
        return toast.error('Please Select Brand Monthly Volume');
      if (!businessDetails.value) return toast.error('Please enter value');
      if (!businessDetails.value_in_inr)
        return toast.error('Please enter value in Lacs');

      payload = {
        other_business_details: {
          firm_id: firmDetails.company_id,
          business_details: [
            {
              id: businessDetails.parent_id,
              // operation_type: OperationType['UPDATE'],
              industry: businessDetails.industry,
              brand_list: [
                {
                  brand_name: businessDetails.name,
                  volume_info: {
                    uom: businessDetails.uom,
                    value: businessDetails.value,
                    value_in_lacs: businessDetails.value_in_inr,
                  },
                  id: businessDetails.id,
                  operation_type: add
                    ? OperationType['ADD']
                    : OperationType['UPDATE'],
                },
              ],
            },
          ],
        },
      };
    }

    // return console.log(payload);

    const { error, message } = await patchbusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className='custom-toast-container' />

      <CardContent>
        {Object.keys(otherBusinessDetails).length > 0 &&
          otherBusinessDetails?.business_details.map((vv) => {
            const isFmcg = !vv?.industry;
            return (
              <Accordion
                sx={{
                  marginBottom: 1.5,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1-content'
                  id='panel1-header'
                  sx={{
                    padding: 1,
                    paddingLeft: 2,
                    paddingRight: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <Typography fontWeight={'600'}>
                      {otherBusinessDetails?.firm_info.name} |{' '}
                      {vv.industry || vv.store_type}
                    </Typography>

                    <Button
                      onClick={(event) => {
                        event.stopPropagation();
                        onAdding(vv);
                      }}
                      variant='outlined'
                      style={{
                        marginRight: 10,
                      }}
                    >
                      <Typography>Add Brand</Typography>
                    </Button>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {isFmcg && (
                    <>
                      <div
                        className='row-center'
                        style={{
                          justifyContent: 'space-between',
                          marginBottom: 10,
                        }}
                      >
                        <div
                          className='row-center'
                          style={{
                            marginLeft: 10,
                          }}
                        >
                          <Typography
                            fontSize={15}
                            sx={{ marginRight: 1 }}
                          >
                            Brands Dealing in (Nos)
                          </Typography>
                          -
                          <Typography
                            fontSize={15}
                            fontWeight={'600'}
                            sx={{ marginLeft: 1, marginRight: 1 }}
                          >
                            {vv.no_of_brands_dealing_in}
                          </Typography>
                        </div>

                        <div
                          className='row-center'
                          style={{
                            marginLeft: 10,
                          }}
                        >
                          <Typography
                            fontSize={15}
                            sx={{ marginRight: 1 }}
                          >
                            Monthly Turnover (Lacs)
                          </Typography>
                          -
                          <Typography
                            fontSize={15}
                            fontWeight={'600'}
                            sx={{ marginLeft: 1 }}
                          >
                            {vv.monthly_turnover_lacs}
                          </Typography>
                        </div>
                      </div>

                      <div
                        className='row-center'
                        style={{
                          justifyContent: 'space-between',
                          marginBottom: 20,
                        }}
                      >
                        <div
                          className='row-center'
                          style={{
                            marginLeft: 10,
                          }}
                        >
                          <Typography
                            fontSize={15}
                            sx={{ marginRight: 1 }}
                          >
                            Types Of Product
                          </Typography>
                          -
                          <Typography
                            fontSize={15}
                            fontWeight={'600'}
                            sx={{ marginLeft: 1, marginRight: 1 }}
                          >
                            {vv.types_of_products.join(', ')}
                          </Typography>
                        </div>

                        <div
                          className='row-center'
                          style={{
                            marginLeft: 10,
                          }}
                        >
                          <Typography
                            fontSize={15}
                            sx={{ marginRight: 1 }}
                          >
                            Refrigerating Units (Nos)
                          </Typography>
                          -
                          <Typography
                            fontSize={15}
                            fontWeight={'600'}
                            sx={{ marginLeft: 1 }}
                          >
                            {vv.number_of_refrigerating_units}
                          </Typography>
                        </div>
                      </div>

                      <div
                        className='row-center'
                        style={{
                          justifyContent: 'center',
                          marginBottom: 10,
                        }}
                      >
                        <Typography>
                          Added Brands for {vv?.store_type}
                        </Typography>
                      </div>
                    </>
                  )}

                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '20px',
                    }}
                  >
                    {vv?.brand_list &&
                      vv?.brand_list?.map((brand) => {
                        return (
                          <Box
                            sx={{
                              borderWidth: 2,
                              borderColor: '#F59C1E',
                              borderStyle: 'solid',
                              padding: 2,
                              borderRadius: 2,
                              position: 'relative',
                              marginBottom: 4,
                            }}
                          >
                            <div
                              className='editCtr'
                              onClick={() => onEdit(vv, brand, !isFmcg)}
                            >
                              <Tooltip title='Edit Details'>
                                <EditIcon color='primary' />
                              </Tooltip>
                            </div>
                            <div
                              className='row-center'
                              style={{
                                justifyContent: 'space-between',
                                marginBottom: 10,
                              }}
                            >
                              <div className='row-center'>
                                <Typography
                                  fontSize={15}
                                  fontWeight={'600'}
                                  sx={{ marginRight: 1.5 }}
                                >
                                  {brand.brand_name}
                                </Typography>
                              </div>

                              <div className='row-center'>
                                <div
                                  className='row-center'
                                  style={{
                                    marginLeft: 10,
                                  }}
                                >
                                  <Typography
                                    fontSize={15}
                                    sx={{ marginRight: 1 }}
                                  >
                                    {isFmcg
                                      ? 'Monthly Volume'
                                      : 'Monthly (Lacs)'}
                                  </Typography>
                                  -
                                  <Typography
                                    fontSize={15}
                                    fontWeight={'600'}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    {isFmcg
                                      ? brand?.brand_monthly_volume
                                      : Intl.NumberFormat('en-IN').format(
                                          brand?.volume_info?.value_in_lacs,
                                        )}
                                  </Typography>
                                </div>
                              </div>
                            </div>

                            <div
                              className='row-center'
                              style={{
                                justifyContent: 'space-between',
                                marginBottom: 10,
                              }}
                            >
                              {isFmcg ? (
                                <div className='row-center'>
                                  <Typography
                                    fontSize={15}
                                    sx={{ marginRight: 1 }}
                                  >
                                    Is Distributor
                                  </Typography>
                                  -
                                  <Typography
                                    fontSize={15}
                                    fontWeight={'600'}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    {brand.is_distributor ? 'Yes' : 'No'}
                                  </Typography>
                                </div>
                              ) : (
                                <div className='row-center' />
                              )}

                              {!isFmcg && (
                                <div className='row-center'>
                                  <Typography
                                    fontSize={15}
                                    sx={{ marginRight: 1 }}
                                  >
                                    Monthly Volume
                                  </Typography>
                                  -
                                  <Typography
                                    fontSize={15}
                                    fontWeight={'600'}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    {Intl.NumberFormat('en-IN').format(
                                      brand?.volume_info?.value,
                                    )}{' '}
                                    {brand?.volume_info?.uom}
                                  </Typography>
                                </div>
                              )}
                            </div>

                            {isFmcg && (
                              <div
                                className='row-center'
                                style={{
                                  justifyContent: 'space-between',
                                  marginBottom: 10,
                                }}
                              >
                                <div className='row-center'>
                                  <Typography
                                    fontSize={15}
                                    sx={{ marginRight: 1 }}
                                  >
                                    Contact Name
                                  </Typography>
                                  -
                                  <Typography
                                    fontSize={15}
                                    fontWeight={'600'}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    {brand.contact_person_name}
                                  </Typography>
                                </div>

                                <div className='row-center'>
                                  <Typography
                                    fontSize={15}
                                    sx={{ marginRight: 1 }}
                                  >
                                    Contact Number
                                  </Typography>
                                  -
                                  <Typography
                                    fontSize={15}
                                    fontWeight={'600'}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    {brand.contact_person_number}
                                  </Typography>
                                </div>
                              </div>
                            )}
                          </Box>
                        );
                      })}
                  </div>
                </AccordionDetails>
              </Accordion>
            );
          })}
      </CardContent>

      <div
        className='row-center'
        style={{
          justifyContent: 'flex-end',
        }}
      >
        <div>
          <Button
            onClick={handleOpen}
            sx={{ width: 150 }}
            variant='contained'
          >
            Add Details
          </Button>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            backgroundColor: 'white',
            width: '70%',
            overflowY: 'scroll',
            maxHeight: '90vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}
              >
                Add {adding ? 'Brand' : 'Business'} Details
              </Typography>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Select Firm type
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  disabled={addedBrands.length > 0 || editing || adding}
                  fullWidth
                  margin='normal'
                >
                  <InputLabel id='demo-simple-select-label-industry'>
                    Select Firm type
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label-industry'
                    id='demo-simple-select'
                    value={selectedIndustry.id || ''}
                    label='Select Firm type'
                    onChange={(e) => {
                      const value = e.target.value;
                      const found = industryList.find((vv) => vv.id === value);
                      setSelectedIndustry(found);
                      setBusinessDetails({});
                      setAddedBrands([]);
                    }}
                  >
                    {industryList.map((item) => (
                      <MenuItem value={item.id}>{item.title}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Firm Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Firm Name'
                  name='name'
                  value={firmDetails?.company_name}
                  disabled
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            {selectedIndustry?.id === primaryIndustry['BCM'] && (
              <>
                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Industry
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <FormControl
                      disabled={addedBrands.length > 0 || adding || editing}
                      fullWidth
                      margin='normal'
                    >
                      <InputLabel id='demo-simple-select-label-industry'>
                        Select Industry
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label-industry'
                        id='demo-simple-select'
                        value={businessDetails?.industry || ''}
                        label='Select Industry'
                        onChange={(e) => {
                          const value = e.target.value;
                          setBusinessDetails((prev) => ({
                            ...prev,
                            industry: value,
                          }));
                        }}
                      >
                        {storetypeList.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Brand Name
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <TextField
                      label='Brand Name'
                      name='name'
                      value={businessDetails?.name || ''}
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        setBusinessDetails((prev) => ({
                          ...prev,
                          name: value,
                        }));
                      }}
                      margin='normal'
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: '60%',
                      justifyContent: 'space-between',
                      marginRight: 40,
                    }}
                  >
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Volume in UOM
                    </Typography>
                    <FormControl
                      style={{
                        width: 200,
                      }}
                      // disabled={isEditing || isAddingMember}
                      // fullWidth
                      margin='normal'
                    >
                      <InputLabel id='demo-simple-select-label-uom'>
                        UOM
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label-uom'
                        id='demo-simple-select'
                        value={businessDetails?.uom || ''}
                        label='UOM'
                        onChange={(e) => {
                          const value = e.target.value;
                          setBusinessDetails((prev) => ({
                            ...prev,
                            uom: value,
                          }));
                        }}
                      >
                        {uomList.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      label='Enter Value'
                      name='name'
                      value={businessDetails?.value || ''}
                      // fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        setBusinessDetails((prev) => ({
                          ...prev,
                          value: value,
                        }));
                      }}
                      margin='normal'
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Volume in Lacs
                    </Typography>

                    <TextField
                      label='Enter Value'
                      name='name'
                      value={businessDetails?.value_in_inr || ''}
                      // fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        setBusinessDetails((prev) => ({
                          ...prev,
                          value_in_inr: value,
                        }));
                      }}
                      margin='normal'
                    />
                  </div>
                </div>

                {editing || adding ? (
                  <div
                    className='row-center'
                    style={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div>
                      <Button
                        onClick={() => onEditFinish(adding)}
                        sx={{ marginTop: 2 }}
                        variant='contained'
                      >
                        {adding ? 'Add' : 'Update'} Details
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    className='row-center'
                    style={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div>
                      <Button
                        onClick={addBrand}
                        sx={{ width: 150, marginTop: 2 }}
                        variant='outlined'
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}

            {selectedIndustry?.id === primaryIndustry['FMCG'] && (
              <>
                {adding || editing ? null : (
                  <>
                    <div className='form-row-ctr'>
                      <div className='form-row-ctr-left'>
                        <Typography
                          variant='h6'
                          fontSize={15}
                        >
                          Store Type
                        </Typography>
                      </div>
                      <div className='form-row-ctr-right'>
                        <FormControl
                          disabled={addedBrands.length > 0 || adding}
                          fullWidth
                          margin='normal'
                        >
                          <InputLabel id='demo-simple-select-label-industry'>
                            Store Type
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-label-industry'
                            id='demo-simple-select'
                            value={businessDetails.store_type || ''}
                            label='Store Type'
                            onChange={(e) => {
                              const value = e.target.value;
                              setBusinessDetails((prev) => ({
                                ...prev,
                                store_type: value,
                              }));
                            }}
                          >
                            {storetypeList.map((item) => (
                              <MenuItem value={item}>{item}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className='form-row-ctr'>
                      <div className='form-row-ctr-left'>
                        <Typography
                          variant='h6'
                          fontSize={15}
                        >
                          No. Of Brands Dealing In
                        </Typography>
                      </div>
                      <div className='form-row-ctr-right'>
                        <FormControl
                          disabled={addedBrands.length > 0 || adding}
                          fullWidth
                          margin='normal'
                        >
                          <InputLabel id='demo-simple-select-label-no_of_brands_dealing_in'>
                            No. Of Brands Dealing In
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-label-no_of_brands_dealing_in'
                            id='demo-simple-select'
                            value={
                              businessDetails.no_of_brands_dealing_in || ''
                            }
                            label='No. Of Brands Dealing In '
                            onChange={(e) => {
                              const value = e.target.value;
                              setBusinessDetails((prev) => ({
                                ...prev,
                                no_of_brands_dealing_in: value,
                              }));
                            }}
                          >
                            {brandRangeList.map((item) => (
                              <MenuItem value={item}>{item}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className='form-row-ctr'>
                      <div className='form-row-ctr-left'>
                        <Typography
                          variant='h6'
                          fontSize={15}
                        >
                          Types Of Products
                        </Typography>
                      </div>
                      <div className='form-row-ctr-right'>
                        <FormControl
                          disabled={addedBrands.length > 0 || adding}
                          fullWidth
                          margin='normal'
                        >
                          <InputLabel id='demo-simple-select-label-industry'>
                            Types Of Products
                          </InputLabel>
                          <Select
                            multiple
                            labelId='demo-simple-select-label-industry'
                            id='demo-simple-select'
                            value={businessDetails.types_of_products || []}
                            label='Types Of Products'
                            open={openNoOfBrands}
                            onClose={() => setOpenNoOfBrands(false)}
                            onOpen={() => setOpenNoOfBrands(true)}
                            onChange={(e) => {
                              const value = e.target.value;
                              setOpenNoOfBrands(false);
                              setBusinessDetails((prev) => ({
                                ...prev,
                                types_of_products: value,
                              }));
                            }}
                          >
                            {productTypeList.map((item) => (
                              <MenuItem value={item}>{item}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className='form-row-ctr'>
                      <div className='form-row-ctr-left'>
                        <Typography
                          variant='h6'
                          fontSize={15}
                        >
                          Monthly Turnover Lacs
                        </Typography>
                      </div>
                      <div className='form-row-ctr-right'>
                        <FormControl
                          disabled={addedBrands.length > 0 || adding}
                          fullWidth
                          margin='normal'
                        >
                          <InputLabel id='demo-simple-select-label-industry'>
                            Monthly Turnover Lacs
                          </InputLabel>
                          <Select
                            labelId='demo-simple-select-label-industry'
                            id='demo-simple-select'
                            value={businessDetails.monthly_turnover_lacs || ''}
                            label='Monthly Turnover Lacs'
                            onChange={(e) => {
                              const value = e.target.value;
                              setBusinessDetails((prev) => ({
                                ...prev,
                                monthly_turnover_lacs: value,
                              }));
                            }}
                          >
                            {monthlyTurnOverList.map((item) => (
                              <MenuItem value={item}>{item}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    <div className='form-row-ctr'>
                      <div className='form-row-ctr-left'>
                        <Typography
                          variant='h6'
                          fontSize={15}
                        >
                          Number of Refrigerating units
                        </Typography>
                      </div>
                      <div className='form-row-ctr-right'>
                        <TextField
                          disabled={addedBrands.length > 0 || adding}
                          label='Number of Refrigerating units'
                          name='name'
                          value={
                            businessDetails.number_of_refrigerating_units || ''
                          }
                          fullWidth
                          onChange={(e) => {
                            const value = e.target.value;
                            setBusinessDetails((prev) => ({
                              ...prev,
                              number_of_refrigerating_units: value,
                            }));
                          }}
                          margin='normal'
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Brand Name
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <TextField
                      label='Brand Name'
                      name='name'
                      value={businessDetails?.name || ''}
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        setBusinessDetails((prev) => ({
                          ...prev,
                          name: value,
                        }));
                      }}
                      margin='normal'
                    />
                  </div>
                </div>

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Brand Monthly Volume in Lacs
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <FormControl
                      // disabled={isEditing || isAddingMember}
                      fullWidth
                      margin='normal'
                    >
                      <InputLabel id='demo-simple-select-label-monthly_volume_in_lacs'>
                        Select Turnover
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label-monthly_volume_in_lacs'
                        id='demo-simple-select'
                        value={businessDetails?.brand_monthly_volume || ''}
                        label='Select Turnover'
                        onChange={(e) => {
                          const value = e.target.value;
                          setBusinessDetails((prev) => ({
                            ...prev,
                            brand_monthly_volume: value,
                          }));
                        }}
                      >
                        {brandMonthlyVolumeList.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Are you Distributor for this Brand?
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <FormControl
                      // disabled={isEditing || isAddingMember}
                      fullWidth
                      margin='normal'
                    >
                      <InputLabel id='demo-simple-select-label-is_distributor'>
                        Are you Distributor for this Brand?
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label-is_distributor'
                        id='demo-simple-select'
                        value={businessDetails?.is_distributor || ''}
                        label='Are you Distributor for this Brand?'
                        onChange={(e) => {
                          const value = e.target.value;
                          setBusinessDetails((prev) => ({
                            ...prev,
                            is_distributor: value,
                          }));
                        }}
                      >
                        <MenuItem value={'true'}>Yes</MenuItem>
                        <MenuItem value={'false'}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Enter Contact Person Name for this brand
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <TextField
                      label='Contact Person Name'
                      name='name'
                      value={businessDetails?.contact_person_name || ''}
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        setBusinessDetails((prev) => ({
                          ...prev,
                          contact_person_name: value,
                        }));
                      }}
                      margin='normal'
                    />
                  </div>
                </div>

                <div className='form-row-ctr'>
                  <div className='form-row-ctr-left'>
                    <Typography
                      variant='h6'
                      fontSize={15}
                    >
                      Enter Contact Person Number for this brand
                    </Typography>
                  </div>
                  <div className='form-row-ctr-right'>
                    <TextField
                      label='Contact Person Number'
                      name='name'
                      value={businessDetails?.contact_person_number || ''}
                      fullWidth
                      onChange={(e) => {
                        if (
                          /^\d*$/.test(e.target.value) &&
                          e.target.value.length <= 10
                        ) {
                          setBusinessDetails((prev) => ({
                            ...prev,
                            contact_person_number: e.target.value,
                          }));
                        }
                      }}
                      margin='normal'
                    />
                  </div>
                </div>

                {editing || adding ? (
                  <div
                    className='row-center'
                    style={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div>
                      <Button
                        onClick={() => onEditFinish(adding)}
                        sx={{ marginTop: 2 }}
                        variant='contained'
                      >
                        {adding ? 'Add' : 'Update'} Details
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    className='row-center'
                    style={{
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div>
                      <Button
                        onClick={addBrand}
                        sx={{ width: 150, marginTop: 2 }}
                        variant='outlined'
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                )}
              </>
            )}
          </CardContent>

          {selectedIndustry?.id === primaryIndustry['BCM'] &&
            addedBrands.length > 0 && (
              <CardContent>
                <div
                  className='row-center'
                  style={{
                    justifyContent: 'center',
                    marginBottom: 10,
                  }}
                >
                  <Typography>
                    Added Brands for {businessDetails?.industry}
                  </Typography>
                </div>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label='simple table'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Brand Name</TableCell>
                        <TableCell align='right'>UOM</TableCell>
                        <TableCell align='right'>Value</TableCell>
                        <TableCell align='right'>Volume in Lacs</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {addedBrands.map((row) => (
                        <TableRow
                          key={row.brand_name}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell
                            component='th'
                            scope='row'
                          >
                            {row.brand_name}
                          </TableCell>
                          <TableCell align='right'>
                            {row.volume_info.uom}
                          </TableCell>
                          <TableCell align='right'>
                            {row.volume_info.value}
                          </TableCell>
                          <TableCell align='right'>
                            {row.volume_info.value_in_lacs}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <div
                  className='row-center'
                  style={{
                    justifyContent: 'flex-end',
                  }}
                >
                  <div>
                    <Button
                      onClick={onFinish}
                      sx={{ marginTop: 2 }}
                      variant='contained'
                    >
                      Submit Details
                    </Button>
                  </div>
                </div>
              </CardContent>
            )}

          {selectedIndustry?.id === primaryIndustry['FMCG'] &&
            addedBrands.length > 0 && (
              <CardContent>
                <div
                  className='row-center'
                  style={{
                    justifyContent: 'center',
                    marginBottom: 10,
                  }}
                >
                  <Typography>
                    Added Brands for {businessDetails?.store_type}
                  </Typography>
                </div>
                <div></div>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label='simple table'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Brand Name</TableCell>
                        <TableCell align='right'>
                          Monthly Volume in Lacs
                        </TableCell>
                        <TableCell align='right'>
                          Distributor for this Brand?
                        </TableCell>
                        <TableCell align='right'>Contact Person Name</TableCell>
                        <TableCell align='right'>
                          Contact Person Number
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {addedBrands.map((row) => (
                        <TableRow
                          key={row.brand_name}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell
                            component='th'
                            scope='row'
                          >
                            {row.brand_name}
                          </TableCell>
                          <TableCell align='right'>
                            {row.brand_monthly_volume}
                          </TableCell>
                          <TableCell align='right'>
                            {row.is_distributor ? 'Yes' : 'No'}
                          </TableCell>
                          <TableCell align='right'>
                            {row.contact_person_name}
                          </TableCell>
                          <TableCell align='right'>
                            {row.contact_person_number}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <div
                  className='row-center'
                  style={{
                    justifyContent: 'flex-end',
                  }}
                >
                  <div>
                    <Button
                      onClick={onFinish}
                      sx={{ marginTop: 2 }}
                      variant='contained'
                    >
                      Submit Details
                    </Button>
                  </div>
                </div>
              </CardContent>
            )}
        </Box>
      </Modal>
    </div>
  );
}

export default OtherBusinessDetails;
